import React from 'react';
import styled from 'styled-components';
import { ACCENT_COLOR, BTN, NAME_SECTION, PADDING, FONTSIZETITLE } from '../styles/style';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useMemo } from 'react';

const Section = styled.section`
  height: auto;
  background-color:rgb(52, 58, 64);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  position: relative;
  ${PADDING};
`;

const AnimatedText = styled(motion.div)`
  width: 100%;
    max-width: 1300px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
    .title{
    position: relative;
    color:white;
    width: 100%;
    ${FONTSIZETITLE};
    &::after{
      color:#FFFFFF60 !important;
    content: "OFERTA";
    ${NAME_SECTION};
    width: 100%;
  }
  }
  .container-services{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap:60px;
     margin-top:60px;
    @media(min-width:768px){margin-top:100px;}
    margin-bottom:60px;
    color:white;
    .service-item{
      text-align: left;
      width:100%;
      max-width: 620px;
      h3{font-size:1.5rem;}
      p{
        font-size:1rem;
        color:#ffffff99;
        margin-top:10px;
      }
    }
  }
`;

const Services = () => {
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
    const options = useMemo(() => ({
    triggerOnce: true,
    threshold: isMobile ? 0.3 : 0.6,
    rootMargin: isMobile ? '-60px 0px 0px 0px' : '-100px 0px 0px 0px',
  }), []);
  
  const [ref, inView] = useInView(options);

  const services = [
    {id:1, title:"Strony internetowe", description:"Tworzę strony internetowe oparte na CMS WordPress, zoptymalizowane pod SEO. Jako freelancer zapewniam indywidualne podejście i dostosowanie projektu do potrzeb klienta."},
    {id:2, title:"Landing page na podstawie projektu graficznego", description:"Realizuję responsywne landing page w czystym HTML, CSS, JavaScript oraz z wykorzystaniem React.js. Pracuję na bazie dostarczonych plików graficznych (np. PSD, Figma)."},
    {id:3, title:"Rozwój funkcjonalności sklepów e-commerce", description:"Wdrażam i rozwijam funkcje w sklepach opartych na WooCommerce. Skupiam się na lekkich i zoptymalizowanych rozwiązaniach, ograniczając liczbę zewnętrznych wtyczek."},
    {id:4, title:"Administracja i utrzymanie sklepów", description:"Zajmuję się obsługą techniczną e-sklepów – od aktualizacji i backupów, po zabezpieczenia i monitoring. Dbam o stabilność i bezpieczeństwo działania systemu."}
  ]

  return (
    <Section id="services" ref={ref}>
      <AnimatedText
        initial={{ opacity: 0}}
        animate={inView ? { opacity: 1 } : {}}
        transition={{ duration: 1.2, ease: 'easeOut' }}
      >
        <div className="title">
          <h2>Co robię?</h2>
          <p className="subtitle"></p>
        </div>
        <div className="container-services">
        {services.map((service, key) => (
          <div key={service.id} className="service-item">
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </div>
        ))}
      </div>
      </AnimatedText>
    </Section>
  );
};

export default Services;
